import React from 'react';
import {useAxios} from '../hooks';

const useServicos = () => {
    const {getApiEmitirNotas} = useAxios();

    const novoServico = async () => {
        const api = await getApiEmitirNotas();
        const result = await api.post('/servicos');
        return result.data;
    }

    
    const servicoXPedido = async (data) => {
        const api = await getApiEmitirNotas();
        const result = await api.post('/servicos/servicoXPedido', data);
        return result.data;
    }

    return {novoServico, servicoXPedido};
}

export { useServicos };